import { disabled } from '../general'

const Fill = {
  label: 'Fill Space',
  key: 'fill',
  fields: [disabled]
}

export { Fill }
